import React, {useEffect, useState} from 'react';
import UserManualBanner from "../../../assets/images/BreachRisk_Interactive_Users_Guide_Banner.svg";
import {Card, CardGroup, Col, Row} from "reactstrap";
import {Link as ExternalLink} from "@mui/material";
import {HashLink as Link} from "react-router-hash-link";

import BBIconSettings from "../../../assets/bbCustomIcons/BBIconSettings";
import BBIconBellService from "../../../assets/bbCustomIcons/BBIconBellService";
import UserManualHeaderWidget from "./UserManualHeaderWidget";
import {useDispatch, useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf, bbScopeIcon, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import CIRTUserManual from "./CIRTUserManualComponent";
import BBIconHexModule from "../../../assets/bbCustomIcons/BBIconHexModule";
import {Accordion, AccordionDetails, AccordionSummary, Button} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BRBusinessAttacksAuthorizedControlWidget
    from "../../../components/customBreachBits/controllers/BRBusinessAttacksAuthorizedControlWidget";
import TileBreachRiskScoreWithBasicDial
    from "../../../components/customBreachBits/metrics/TileBreachRiskScoreWithBasicDial";
import RequestBRBusinessShareDialog
    from "../../../components/customBreachBits/BreachRiskSharing/RequestBRBusinessShareDialog";
import BRPortfolioAddNewEntityDialog
    from "../../../components/customBreachBits/BRPortfolio/BRPortfolioAddNewEntityDialog";
import BBIconBreachRiskScore from "../../../assets/bbCustomIcons/BBIconBreachRiskScore";
import Widget from "../../../components/prefabricated/Widget";
import {fetchCustomers} from "../../../actions";
import BRFidelityBadge from "../../../components/customBreachBits/BRPortfolio/BRFidelityBadge";
import NewBRTargetIpProvidedForm
    from "../../../components/customBreachBits/BreachRiskValidationProviding/NewBRTargetIpProvidedForm";
import NewBRProvidingElementDialog
    from "../../../components/customBreachBits/BreachRiskValidationProviding/NewBRProvidingElementDialog";
import NewBRDomainProvidedForm
    from "../../../components/customBreachBits/BreachRiskValidationProviding/NewBRDomainProvidedForm";
import NewBRSubdomainProvidedForm
    from "../../../components/customBreachBits/BreachRiskValidationProviding/NewBRSubdomainProvidedForm";
import NewBRValidationDialog
    from "../../../components/customBreachBits/BreachRiskValidationProviding/NewBRValidationDialog";
import BBIconAttestation from "../../../assets/bbCustomIcons/BBIconAttestation";
import BBIconVerified from "../../../assets/bbCustomIcons/BBIconVerified";
import BBIconTechData from "../../../assets/bbCustomIcons/BBIconTechData";
import BBIconReportOverview from "../../../assets/bbCustomIcons/BBIconReportOverview";
import BBIconFolderSettings from "../../../assets/bbCustomIcons/BBIconFolderSettings";
import BBIconFAQQuestionChat from "../../../assets/bbCustomIcons/BBIconFAQQuestionChat";
import BBIconBreachRiskGauge from "../../../assets/bbCustomIcons/BBIconBreachRiskGauge";
import VectorRisk2DScatterPlot from "../../../components/customBreachBits/charts/VectorRisk2DScatterPlot";
import BRThreatsTechnicalTable from "../../../components/customBreachBits/BreachRiskReport/BRThreatsTechnicalTable";
import BBIconKnowledgeBaseBook from "../../../assets/bbCustomIcons/BBIconKnowledgeBaseBook";
// import SubscriptionBRExpiredModal from "../../../components/customBreachBits/modals/SubscriptionBRExpiredModal";
import BBIconProductFeaturesList from "../../../assets/bbCustomIcons/BBIconProductFeaturesList";


const UsersGuidePage = (props) =>{
    const {location, match} = props;

    const dispatch = useDispatch();

    const {customers, loadingCustomers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const authUser = useSelector(({auth}) => auth.authUser);
    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const isCustomer = isCurrentUserMemberOf(authUser, "customer");
    const isBRPortfolioCustomer = isCurrentUserMemberOf(authUser,"breachrisk_portfolio");
    const isBRBusinessCustomer = isCurrentUserMemberOf(authUser,"breachrisk");
    const isPartner = isCurrentUserMemberOf(authUser,"partner");

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const [expanded, setExpanded] = useState(false);
    const [openRequestShareDialog, setOpenRequestShareDialog] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    useEffect(()=>{
        if(!customers && !loadingCustomers){
            dispatch(fetchCustomers());
        }
    }, [customers])

 return(
     // <SubscriptionBRExpiredModal subscriptionTypesArray={[1,2,3]}>
     <div className="app-wrapper animated fadeIn animation-duration-7">
         <Row>

             <Col lg={6}>
                 <div className={"mx-0 px-0 "}>
                     <div style={{backgroundImage: `url(${UserManualBanner})`,  width: "400px", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                 </div>
             </Col>

         </Row>
         <hr/>

         <Row>
             {/*<Col>*/}
             {/*    <UserManualHeaderWidget title={"Guided Tour"}*/}
             {/*                            subtitle={"Select the beacon in the bottom left to begin."}*/}
             {/*                            icon={<BBIconTutorialArrows  style={{fontSize: "70px"}}/>}/>*/}
             {/*</Col>*/}

             {/*<Col>*/}
             {/*        /!*<Link smooth to={{hash: "ModulesSection"}}>*!/*/}
             {/*            <UserManualHeaderWidget title={"Controls"}*/}
             {/*                                    subtitle={"Control and operate your service"}*/}
             {/*                                    icon={<BBIconControls  style={{fontSize: "70px"}}/>}/>*/}
             {/*        /!*</Link>*!/*/}
             {/*</Col>*/}

             <Col>
                 <Link smooth to={{pathname: "/board/settings/account"}}>
                     <UserManualHeaderWidget title={"Settings"}
                                             subtitle={"Company and personal preferences."}
                                             icon={<BBIconSettings  style={{fontSize: "70px"}}/>}/>
                 </Link>
             </Col>

             <Col>
                 <Link smooth to={{pathname: "/board/settings/subscription"}}>
                     <UserManualHeaderWidget title={"Subscription"}
                                             subtitle={"Manage features & payments."}
                                             icon={<BBIconProductFeaturesList  style={{fontSize: "70px"}}/>}/>
                 </Link>
             </Col>

             <Col>
                 <Link smooth to={{pathname: "/board/faq"}}>
                     <UserManualHeaderWidget title={"FAQ"}
                                             subtitle={"Frequently Asked Questions."}
                                             icon={<BBIconFAQQuestionChat  style={{fontSize: "70px"}}/>}/>
                 </Link>
             </Col>
             <Col>
                 <ExternalLink  target="_blank" rel="noopener" href={"https://support.breachbits.com/knowledge"} className={"text-decoration-none"}>
                     <UserManualHeaderWidget title={"Knowledge Base"}
                                             subtitle={"More how-to & support."}
                                             icon={<BBIconKnowledgeBaseBook  style={{fontSize: "70px"}}/>}/>
                 </ExternalLink>
             </Col>

             <Col>
                 <Link smooth to={{pathname: "/board/contact"}}>
                     <UserManualHeaderWidget title={"Contact"}
                                             subtitle={"Feedback, support, and anything else."}
                                             icon={<BBIconBellService  style={{fontSize: "70px"}}/>}/>
                 </Link>
             </Col>


         </Row>

         {/*{(isBRPortfolioCustomer || isBRBusinessCustomer || isStaffAdmin) &&*/}

         <h1 className={"bb-font-fridge-bold m-1 p-0"} style={{fontSize: 55}}>
             <BBIconBreachRiskGauge className={"mr-3"} style={{fontSize: 90}}/>
             <span className={"text-primary"}>
                                    About BreachRisk&trade;
                                </span>
         </h1>
         <p>
             BreachRisk™ is a family of concepts and solutions designed to fairly, accurately, and repeatably measure the likelihood
             and impact of cyber threats to an organization. Using a hacker's perspective, BreachRisk™ delivers an easy to understand view of your company's infrastructure and the
             elements that may be at risk. State of the art technology means we are continuously monitoring your infrastructure and how
             hackers are developing and carrying out attacks.</p>
         {/*<h1 style={{fontSize: "45px",}} className={"col-12 text-center"}>Monitor Your Risk</h1>*/}

         {/*<p><em>With three levels of detail, BreachRisk™ solutions deliver the right information to the right people.</em></p>*/}

         <Card className={"jr-card jr-card-widget bg-lighter-gray"} >
             <CardGroup >
                <Row style={{width: "100%"}} className={"jr-card-header"}>
                     <Col lg={4} className={" m-0 title"}>
                         <h1 style={{fontSize: "45px",}}>Monitor Your Risk</h1>
                     </Col>
                    <Col className={"bb-font-fridge-light m-0 align-content align-self-center m-0 p-0"}>
                        <h3>With three levels of detail deliver the right information to the right people.</h3>
                    </Col>
                </Row>
         <Row>
             <Col lg={8} >
                 <Widget>
                     <Row>
                         <Col className={""} sm={9}>
                             <h1><small>Level 1:</small> BreachRisk™ Score - <em>start with the big picture</em></h1>
                         </Col>
                         <Col className={"icon-btn align-self-center"}>
                             <h4 className={"text-right icon-btn"}>
                                 <Link to={`/board/BreachRisk/Business/Score`}>
                                     <Button
                                             variant="outlined"
                                             color="default"
                                             className={"text-electric-blue m-0 text-center"}>
                                         <BBIconBreachRiskScore/> &nbsp;BreachRisk™ Score
                                     </Button>
                                 </Link>
                             </h4>
                         </Col>
                     </Row>
                         {/*<Row id={"BreachRiskSection"} className={"col-12 align-self-center p-2 m-0"}>*/}
                         {/*        <Col lg={12}>*/}
                         {/*            <div className={"m-1"}>*/}
                                         <p>Use the BreachRisk Score to provide a scalable, realistic, and understandable metric, enabling productive decisions and conversations.
                                             BreachRisk Scores come with additional pieces of context, including fidelity and risk level. </p>

                                         <h4>Score Basics:</h4>
                                         <ul>
                                             <li>10-point scale</li>
                                             <li>A lower number represents a lower cyber risk</li>
                                             <li><strong>Fidelity</strong> is a measure of confidence in our
                                                 conclusions.</li>
                                             <li><strong>Risk level</strong> is the simplest distillation of a score. The risk level is categorized
                                                 as either
                                                 <ul>
                                                     <li>Very Low</li>
                                                     <li>Low</li>
                                                     <li>Medium</li>
                                                     <li>High</li>
                                                     <li>Very High</li>
                                                 </ul>
                                             </li>
                                         </ul>
                                         <p>
                                             Most companies will have a BreachRisk Score between 4.0 and 6.0, a "Medium Risk." Medium risk companies have room for improvement but hackers may choose to focus on attacking companies with higher risk. A company with High or Very High risk should consider taking actions to bolster their defense.

                                         </p>
                     <h4><strong>Interact Now:</strong> Your live BreachRisk™ Score and risk category is shown in the dial on the right.</h4>

                     <h4>
                                             <em>Available in all BreachRisk™ for Business plans.</em>
                                         </h4>
                                     {/*</div>*/}

                                 {/*</Col>*/}
                         {/*</Row>*/}
                 </Widget>

             </Col>
             <Col lg={4} className={"mb-0 pb-0 align-self-center"}>
                 {/*<Widget styleName={"m-0 p-0"}>*/}
                 {/*    <div className={"row m-0 p-0"}>*/}
                 {/*                <div className="col-12 m-1 p-1">*/}
                                     <TileBreachRiskScoreWithBasicDial entityId={entityInView} displaySmall={false}/>
                                 {/*</div>*/}
                     {/*</div>*/}
                 {/*</Widget>*/}
             </Col>
         </Row>

         <Row className={"mt-0 pt-0"}>

             <Col className={"mb-0 pb-0"} lg={8} sm={12}>
                 <Widget>
                     <Row>
                         <Col className={"align-self-center"} sm={9}>
                             <h1><small>Level 2:</small> BreachRisk™ Report - <em>understand your score</em></h1>
                         </Col>
                         <Col className={"icon-btn align-self-center"}>
                             <h4 className={"text-right icon-btn"}>
                                 <Link to={`/board/BreachRisk/Business/Report/Overview`}>
                                     <Button
                                             variant="outlined"
                                             color="default"
                                             className={"text-electric-blue m-0 text-center"}>
                                         <BBIconReportOverview/> &nbsp;BreachRisk™ Report
                                     </Button>
                                 </Link>
                             </h4>
                         </Col>
                     </Row>

                     <p>Use your BreachRisk Report for facilitating conversations between departments in your own company, or use the report to prove the success and security of your product by
                         sharing it with companies of your choosing. Available for Pro and Premium plans, the BreachRisk Report
                         gives you access to insights on issues that are hurting and helping your score, enabling you to
                         easily find, fix, and improve your score quickly. </p>

                     <p>When you need to know why, BreachRisk Report provides insights on helpful and harmful factors, as well as deeper insights on threats that attackers could use to cause
                         a breach. We facilitate secure sharing of this information with organizations you select so that you can further prove security, and work with others without divulging
                         unnecessary and potentially harmful technical details.</p>
                     <p>The “Risk Chart: Notable Threats” provides basic information on all identified threats. Using time-tested risk management principles, each threat is plotted on a risk chart to help
                         you quickly identify the most dangerous threats while conserving resources.
                     </p>
                     <h4><strong>Interact Now:</strong> Identify the most dangerous threats we've identified using this risk management chart.</h4>

                     <h4>
                         <em>Available in all BreachRisk™ for Business plans, with some features reserved for Pro and Premium levels.</em>
                     </h4>
                 </Widget>
             </Col>
             <Col className={"mb-0 pb-0 align-self-center"}>
                 {/*<Widget>*/}
                 {/*    <div className={"row"}>*/}
                 {/*        <div className="col-12">*/}
                 {/*            <div className="row text-center align-self-center">*/}
                 {/*<div className="m-1 p-1">*/}
                     <VectorRisk2DScatterPlot entity={entityInView}/>
                 {/*</div>*/}
                 {/*</div>*/}
                 {/*        </div>*/}
                 {/*    </div>*/}
                 {/*</Widget>*/}
             </Col>
         </Row>

         <Row>
             <Col className={"mb-0 pb-0 "} lg={8} sm={12}>
                 <Widget>
                     <Row id={"technicalData"}>
                         <Col className={"align-self-center"} sm={8}>
                             <h1><small>Level 3:</small> BreachRisk™ Technical - <em>pinpoint threats</em></h1>
                         </Col>
                         <Col className={"icon-btn align-self-center"}>
                             <h4 className={"text-right icon-btn"}>
                                 <Link to={`/board/BreachRisk/Business/Report/TechData/`}>
                                     <Button
                                         variant="outlined"
                                         color="default"
                                         className={"text-electric-blue m-0 text-center"}>
                                         <BBIconTechData/> &nbsp;BreachRisk™ Technical
                                     </Button>
                                 </Link>
                             </h4>
                         </Col>
                     </Row>

                     <p>There is some information that you would never want to share outside of your organization and named security partners because attackers could use it against you,
                         but your technicians could use it to make you better. This information is kept confidential and only available for those with a BreachRisk
                         for Business plan (Pro level and higher).
                         You can find all the elements discovered in the latest BreachRisk cycle by visiting the Technical Data Page. There, you can find what was
                         discovered, where it was discovered, and when. See more risks or possible vulnerabilities discovered in your infrastructure and find information
                         about how attackers could exploit weaknesses.
                     </p>
                     <p>This detailed look also allows you to track threats and elements with comments and statuses to monitor the progress of threats throughout cycles, as well as other tools to help technicians pinpoint and eliminate threats.</p>
                     <h4><strong>Interact Now:</strong> View the threat vectors we've currently identified using the table to the right.</h4>

                     <h4>
                         <em>Available only in BreachRisk™ for Business Pro and Premium plans.</em>
                     </h4>
                     {/*//TODO:****Create and element that is a select threat and pulls up individual vector cards*****/}
                 </Widget>
             </Col>
             <Col className={"mb-0 pb-0 align-self-center"}>
                 {/*<Widget>*/}
                 {/*    <div className={"row"}>*/}
                 {/*        <div className="col-12">*/}
                 {/*            <div className="row text-center align-self-center">*/}
                 {/*<div className="col-12 m-1 p-1">*/}
                 {/*    <TileBreachRiskTechDataPieVectorStatus/>*/}
                    <BRThreatsTechnicalTable displaySmall/>
                 {/*</div>*/}

                 {/*</div>*/}
                 {/*        </div>*/}
                 {/*    </div>*/}
                 {/*</Widget>*/}
             </Col>
         </Row>
             </CardGroup>
     </Card>

         <Card className={"bg-lighter-gray jr-card jr-card-widget"}>
             <CardGroup>
                 <Row style={{width: "100%"}} className={"jr-card-header"}>
                 <Col className={"text-center m-0 jr-card-header"}>
                     <h1 style={{fontSize: "45px",}} id={"fidelity"}>Verify & Improve Fidelity</h1>
                 </Col>
                 <Col className={"bb-font-fridge-light m-0 align-content align-self-center m-0 p-0"}>
                     <h3>Go beyond observation with pro and premium features</h3>
                 </Col>
                     <Col className={"text-right align-self-center"}>
                         <h1>Your Fidelity: <BRFidelityBadge cycleObject={myEntity && myEntity.last_cycle ? myEntity.last_cycle : null}/></h1>
                     </Col>
         </Row>
             <Row>
                 <Col>
                     <Widget>
                         <h2 className={"jr-card-header"}>Understanding Fidelity To Improve Your Score</h2>
                         <p>
                             In addition to the BreachRisk™ Score, a fidelity level is also provided. Fidelity helps you understand the accuracy of your risk predictions based
                             on the tools and access available to us. Fidelity levels range from Very Low to Very High and provide an indication to your company and any company
                             you share your score with the level of access and certainty you've provided. Fidelity can improve on its own over time, but there are ways to improve it more quickly.
                         </p>
                         <p>
                             Increasing the fidelity of your score can be done in several ways-- by identifying and verifying infrastructure elements, allowing testing, and providing attestations.
                             When you take these actions, you not only improve your fidelity, you get credit for the elements of security you have in place.
                         </p>
                         <p>
                             Companies willing to improve their fidelity not only tend to see an improvement in scores, because they are able to certify the completeness of each report,
                             but help prove their security to other approved parties by showing a dedication to transparency in risk management scoring.
                         </p>
                     </Widget>
                 </Col>

         </Row>

         <Row>
             <Col>
                 <Widget className={"mb-0 pb-0"}>
                     <Row>
                         <Col>
                             <h2 className={"jr-card-header"}>Penetration Testing</h2>
                         </Col>
                     </Row>

                     <Row>
                         <Col>
                             <BRBusinessAttacksAuthorizedControlWidget brSubscriptionRequired={"pro"} />

                         </Col>
                     </Row>
                     <Row>
                         <Col>
                             <p> <small>Enabling Penetration Testing allows BreachRisk&trade; to actively test possible threats. Feature can be enabled or disabled whenever you like. When you share your score, others will know if you have enabled.
                             </small></p>
                         </Col>
                     </Row>
                 </Widget>
             </Col>

             <Col className={"align-self-center"}>
                 <Widget>
                     <h2 className={"jr-card-header"}> Prove Your Security</h2>
                     <p>
                         Our advanced A.I. techniques look at the perimeter of your company's infrastructure, developing a comprehensive understanding of what a hacker sees when planning an attack.
                         With your permission, you can put these elements and your current security measures to the test. When we test elements and fail to breach, their likelihood score-- and your overall score-- go down,
                         meaning that you get credit for the security practices that work for you.
                     </p>
                     <p>
                         {/*{//TODO:/****Something something, continous pen tetings****!/*/}
                     </p>
                     <h4><strong>Interact Now:</strong> Enable or disable Penetration testing using the widget to the left.</h4>

                 </Widget>
             </Col>
         </Row>
<Row>
    <Col lg={8}>
        <Widget>
            <h2>Provide More Information</h2>
            <p>
                BreachRisk&trade; for Business plans allow you to provide elements of your infrastructure to help increase your fidelity and allow for faster verification
                of risk and risk management. Providing these elements increases your fidelity and allows us to test more of your cyberspace.
            </p>
            <p>
                Being actively involved in checking the details of your report allows you to check inaccuracies and contest findings. At a basic level, your involvement and feedback to BreachRisk&trade;
                and to your own team mean continued improvements in your score and fidelity. Find and remove outdated elements from your infrastructure that were discovered to still
                be active. Find all the elements across your infrastructure that may have been missed on other scans.
            </p>
            <h4><strong>Interact Now:</strong> Add an IP address, domain, or subdomain using the buttons to the right.</h4>

        </Widget>
    </Col>
    <Col lg={4}>
        <Widget>
            <Row>
                <Col lg={5}>
                    <h4 className={"jr-card-header align-self-center"}>
                        Go To Verifications:
                    </h4>
                </Col>
                <Col className={"text-center align-self-center"}>
                    <h4>
                        <Button href={`/board/BreachRisk/Business/Verifications`}
                                variant="outlined"
                                color="default"
                                className={"text-electric-blue m-0"}>
                            <BBIconVerified/> &nbsp;Verifications Page
                        </Button>
                    </h4>
                </Col>
            </Row>
            <br/>
            <hr/>
            <Row className={"m-1 text-center"}>
                <Col lg={4}>
                    <NewBRProvidingElementDialog
                        formComponent={<NewBRTargetIpProvidedForm targetEntityId={entityInView}/>}
                        buttonLabel={"IP Address"}
                    />
                </Col>
                <Col lg={4}>
                    <NewBRProvidingElementDialog
                        formComponent={<NewBRDomainProvidedForm targetEntityId={entityInView}/>}
                        buttonLabel={"Domain"}
                    />
                </Col>
                <Col lg={4}>
                    <NewBRProvidingElementDialog
                        formComponent={<NewBRSubdomainProvidedForm targetEntityId={entityInView}/>}
                        buttonLabel={"Subdomain"}
                    />

                </Col>
            </Row>
        </Widget>
    </Col>
    <Col  id={"attestToFindings"} >
        <Widget >
           <h2 className={"jr-card-header"}>Attest to Findings</h2>
{/*TODO:this whole section here*/}
            <p>
                Attestations allow you to certify that you've told us about all of your cyberspace. Making attestations at least every 90 days improves the Fidelity of your BreachRisk™ Score. Attestations improve trust within your cyber ecosystem: stakeholders in need to know that all of your cyberspace has been tested, and attestations increase that trust.
            </p>
            <h4><strong>Interact Now:</strong> Use the buttons below to see if you believe that we have identified all of your company's cyberspace, and submit an attestation if so.</h4>

            <Row>
                <Col className={"text-center align-self-center"}>
                    <h4>
                        <Button href={`/board/BreachRisk/Business/Attestations`}
                                variant="outlined"
                                color="default"
                                className={"text-electric-blue m-0"}>
                           <BBIconAttestation/>&nbsp;  Attestations Page
                        </Button>
                    </h4>
                </Col>
                <Col className={"text-center align-self-center"}>
                    <h4>
                        <NewBRValidationDialog
                            targetEntityId={entityInView}
                        />
                    </h4>
                </Col>
            </Row>
        </Widget>
    </Col>
</Row>
         <Row>
             <Col>
                 <Widget>
                     <h2 id={"determineScope"}>Determine Scope</h2>
                     <p>
                         You're in control of what's being tested. Business plans allow you to remove certain elements from our investigations. Use the {bbScopeIcon(false, 16)} on the element's entry in
                         the technical data table to set and element out of scope. An element marked as out of scope won't be investigated until it is placed back into scope.
                     </p>
                     <p>
                         Out of Scope will not be tested, but you won't get credit for underlying controls that may benefit your BreachRisk™ Score, and it reduces your fidelity.
                         Anything determined to be out of scope also won't see continuing improvements from repeated monitoring and testing.
                     </p>
                     {/*<Col className={"text-center align-self-center"}>*/}
                         <h4 className={"text-center"}>
                             <Link to={`/board/BreachRisk/Business/Report/TechData/`}>
                                 <Button
                                         variant="outlined"
                                         color="default"
                                         className={"text-electric-blue m-0 text-center"}>
                                     <BBIconTechData/> &nbsp;Technical Data Page
                                 </Button>
                             </Link>
                         </h4>
                     {/*</Col>*/}

                 </Widget>
             </Col>
         </Row>
             </CardGroup>
         </Card>

         <Card className={"jr-card jr-card-widget bg-lighter-gray"} >
             <CardGroup >
                 {/*//TODO: This section needs a graphic or dynamic element added to it*/}
                 <Row style={{width: "100%"}} className={"jr-card-header"}>
                     <Col lg={4} className={"text-center m-0 jr-card-header"}>
                         <h1 style={{fontSize: "45px",}}>Understand Your Score</h1>
                     </Col>
                     <Col className={"bb-font-fridge-light m-0 align-content align-self-center m-0 p-0"}>
                         <h3>
                             More than just a number, find out more about how your score is determined
                         </h3>
                     </Col>
                 </Row>
                 <Row style={{width: "100%"}}>
                     <Col lg={12}>
                         <Widget >
                             <h2 className={"jr-card-header"}>Our Risk Principles</h2>
                             <p>Our risk scoring methods are based on dynamic and strategic risk management principles used by
                                 best-in-class organizations from the Pentagon to Wall Street.
                             </p>
                         </Widget>
                     </Col>
                 </Row>
                 <Row>
                     <Col>
                         <Widget>
                             <h2 className={"jr-card-header"}>Risk = Likelihood x Impact</h2>
                             <p>Every threat can be described by how likely it is to occur (likelihood) and the impact to the subject if it were to occur (impact).
                                 Risk is the product of the two. Although some popular cyber risk equations include terms such as threat and vulnerability, even
                                 these can be mathematically simplified into this classic equation. BreachRisk Score answers the question, "what is the relative
                                 risk that a cyber breach will occur to this organization in the foreseeable future?"
                             </p>
                         </Widget>
                     </Col>
                     <Col>
                         <Widget>
                             <h2 className={"jr-card-header"}>CVSS Compatible</h2>
                             <p>Those familiar with cyber risk recognize the time-tested Common Vulnerability Scoring System (CVSS) maintained by the CVSS Special Interest Group.
                                 CVSS is used by the National Institute of Standards and Technology (NIST) National Vulnerability Database (NVD) to characterize the relative risk of
                                 known computer vulnerabilities. BreachRisk considers threats far beyond the NVD with active attack methods and incorporates the CVSS standard to
                                 characterize all threats in a way that is coherent and compatible.</p>
                         </Widget>

                     </Col>
                 </Row>
                 <Row>
                     <Col>
                         <Widget>
                             <h2 className={"jr-card-header"}>How Your Score Is Determined</h2>
                             <p>
                                 Each threat found in your report is given danger rating based on its risk likelihood and impact. This describes how easily an attacker could exploit the threat, and the nominal damage that could be done.
                                 Your score will trend toward the highest of these danger ratings, balanced with other factors.
                             </p>
                             <p>
                                 The frequency with which your score updates depends on the frequency of cycles, which is determined in part by
                                 the level of service. Scores represent a rolling average of the threats in your infrastructure over a given timeline,
                                 usually 90 days. This means that while addressing a threat will show immediately on the next score determination, your scores change will be gradual. Addressing
                                 risk in this way provides an accurate picture of threat and also means that neither a negative or positive score on one threat can result in large swings of your score.

                             </p>
                         </Widget>
                     </Col>
                 </Row>
             </CardGroup>
         </Card>

                 <Card className={"jr-card jr-card-widget bg-lighter-gray"} >
             <CardGroup >
                 <Row style={{width: "100%"}} className={"jr-card-header"}>
                     <Col lg={4} className={"m-0 jr-card-header"}>
                         <h1 style={{fontSize: "45px",}}>Share Your Score</h1>
                     </Col>
                     <Col lg={8} className={"align-self-center m-0"}>
                         <h3>Celebrate Your Success and Prove Your Security When It Matters</h3>
                     </Col>
                 </Row>
                 <Row>
                     <Col>
                         <Widget>
                             <h2>Sharing Principles and Process</h2>
                             <p>
                                 You've worked hard to ensure your organization is secure. Now, take credit and start making returns on that investment.
                                 BreachRisk for Business Pro and Premium give you access to advanced sharing tools such as website badges, allowing you to
                                 persistently prove to others that you take security seriously and that you handle data relationships with care.

                             </p>
                             <p>
                                 Companies with BreachRisk for Portfolio can make requests for a company's report access. You can determine what companies
                                 can see your report and for how long. When you receive the invitation to join BreachRisk or to share your Report, grant
                                 access to those Medium level details you find in your own reports page.
                             </p>
                             <p><strong><em>Those elements included in your technical report
                                 remain visible only to your own organization.</em></strong>
                             </p>
                         </Widget>
                     </Col>
                 </Row>
                 <Row>
                     <Col>
                         <Widget>
                             <h2>Share Your BreachRisk Report</h2>
                             <Row className={"col-12 m-1 d-inline"}>
                                 {/*<Col lg={4} className={"d-inline"}>*/}
                                 {/*   <p> Send your report to the company of your choice here.</p>*/}
                                 {/*</Col>*/}
                                 <Col  lg={4} className={" text-center d-inline"}>
                                     <RequestBRBusinessShareDialog targetEntityId={entityInView}/>
                                 </Col>

                             </Row>
                             <p>
                                 Find more ways to manage your sharing relationships, including authorizing and de-authorizing any shares of your report on your <Link to={`/board/BreachRisk/Business/Share/Current`}>data sharing page.</Link>
                             </p>
                         </Widget>
                     </Col>
                     {isBRPortfolioCustomer || isStaffAdmin &&
                         <Col>
                             <Widget>
                                 <h2>Your Portfolio at Your Fingertips</h2>
                                 <p>
                                     For companies not currently using BreachRisk&trade; you can invite them here.
                                     <div className={"col-12 text-center m-1"}>
                                         <BRPortfolioAddNewEntityDialog targetEntityId={entityInView}/>
                                     </div>
                                 </p>
                                 <p>
                                     If you manage a number of business and security interests, you can view the updated
                                     scores of any company within your portfolio.
                                     <strong><em> A company must authorize access to its report before you are allowed
                                         to view those details.</em></strong>

                                 </p>
                             </Widget>
                         </Col>
                     }
                 </Row>
                 {isBRPortfolioCustomer || isStaffAdmin &&
                     <Row style={{width: "100%"}}>
                         <Col lg={12}>
                             <Widget>
                                 <p>
                                     To request a report from a company already in your portfolio page, visit your <Link
                                     to={`/board/BreachRisk/Portfolio/Manage`}> Manage Portfolio page.</Link>
                                     You'll be able to make the request directly from the list of companies and see if
                                     one has been sent or already approved.
                                 </p>
                                 <h4 className={"text-center"}>
                                     <Button href={`/board/BreachRisk/Portfolio/Manage`}
                                             variant="outlined"
                                             color="default"
                                             className={"text-electric-blue m-0"}>
                                         <BBIconFolderSettings/> &nbsp;Manage Portfolio Page
                                     </Button>
                                 </h4>
                             </Widget>
                         </Col>
                     </Row>
                 }
             </CardGroup>
         </Card>


         {/*}*/}
         <hr/>
         {isCustomer &&
            <div id={"ModulesSection"} className={"col-12 align-self-center p-2 m-0"}>
                            <h1 className={"bb-font-fridge-bold m-1 p-0"} style={{fontSize: 55}}>
                                <BBIconHexModule className={"mr-3"} style={{fontSize: 90}}/>
                                <span className={"text-primary"}>
                                    CIRT: Continuous Intelligent Red Team Service
                                </span>
                            </h1>
                        <CIRTUserManual location={location} match={match}/>
                </div>}


         {/*{(isCustomer || isStaffAdmin || isPartner) &&*/}
         <div className="row my-3">
             <div className="col-12 mb-4 mb-md-0">
                 <h1>General</h1>

         {/*        <Accordion expanded={expanded === 'Methods'} onChange={handleChange('Methods')}>*/}
         {/*            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
         {/*                Overview: CIRT Goals and Methods*/}
         {/*            </AccordionSummary>*/}
         {/*            <AccordionDetails>*/}
         {/*                <div>*/}
         {/*                    <h3>What is CIRT?</h3>*/}
         {/*                    <p>Continuous Intelligent Red Team (CIRT) is an army of hackers - robot hackers.</p>*/}
         {/*                    <p>Allowing good-guy hackers to attempt to breach your company is one of the most effective*/}
         {/*                        ways that a company can increase the culture, process, and technology related to keeping*/}
         {/*                        your information safe.  CIRT heavily employes automation and Artificial Intelligence to find*/}
         {/*                        weaknesses all day, every day.</p>*/}
         {/*                    <h3>What is CIRT doing?</h3>*/}
         {/*                    <p>CIRT emulates malicious hackers of all stripes: from lone-wolf data thieves to Advanced Persistent Threats.*/}
         {/*                        CIRT and the BreachBits team approach your security from the hacker's perspective.  Each adversary we emulate*/}
         {/*                        has a set of tactics, tools, and processes they use to breach your company.  It's our job to do what*/}
         {/*                        the hacker would do, they way they would do it, so that you can stop them before they do it.</p>*/}
         {/*                    <p>First, CIRT conducts reconnaissance to discover your people and systems, where they are, and where they may be vulnerable.*/}
         {/*                        This phase never ends, because your people and systems are always changing and reshaping.</p>*/}
         {/*                    <p>Second, possible vulnerabilities are matched up against CIRT attack capabilities - which grow more adept*/}
         {/*                        and more difficult each week.  When we find a vulnerability that we can match to one of our capabilities, this creates*/}
         {/*                        a <strong>Vector</strong>.  Without a Vector, a hacker cannot achieve a breach.</p>*/}
         {/*                    <p>Third, we attempt to breach you using one or more Vectors.  If we succeed, one or more breaches occurs.  If we fail,*/}
         {/*                        your people and systems have successfully thwarted that Vector.</p>*/}
         {/*                    <p>Finally, we adapt, and you adapt.  Every time you thwart an attack, you gain more insight into the capabilities*/}
         {/*                        of your defenses, and we reward the defense with a more favorable Cyber Risk Rating. But every time we*/}
         {/*                        are able to breach your people and systems, your Cyber Risk Rating deteriorates - but your team adapts, corrects the issue,*/}
         {/*                        and comes back stronger.  Then, we start the cycle again and use tougher techniques.</p>*/}
         {/*                </div>*/}

         {/*            </AccordionDetails>*/}
         {/*        </Accordion>*/}

                 <Accordion id={'safetypromise'} expanded={expanded === 'SafetyPromise'} onChange={handleChange('SafetyPromise')}>
                     <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                         Our Safety Promise
                     </AccordionSummary>
                     <AccordionDetails>
                         <div>
                             <p>Although we use the tricks of the hacker trade, we strictly adhere to Our Safety Promise:</p>
                             <blockquote className={"blockquote"}>
                                 <p>Our Promise: <em>Our services will always be safe and confidential.
                                     We will never destroy, manipulate, or unnecessarily exfiltrate your data, and we will never
                                     disrupt your services without your explicit request and consent.  You will always know if
                                     BreachBits is actively engaging your systems and you will have the control to stop and start our
                                     services in real time. You will have access to the technical information that we discover and generate.
                                     We will provide analytical insights to help you lead your team and manage your risks.</em></p>
                             </blockquote>
                             <p>In other words, we find a way to breach your systems <strong>without harming them</strong>.  If we ever encounter
                                 a situation where your systems, services, or data might be harmed, we stop and contact you before
                                 proceeding.</p>
                         </div>

                     </AccordionDetails>
                 </Accordion>

         {/*        <Accordion expanded={expanded === 'HowUseBreachBoard'} onChange={handleChange('HowUseBreachBoard')}>*/}
         {/*            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
         {/*                How should you use BreachBoard?*/}
         {/*            </AccordionSummary>*/}
         {/*            <AccordionDetails>*/}
         {/*                <div>*/}
         {/*                    <p>You are logged in to the BreachBits BreachBoard, which is also the home of your CIRT dashboards*/}
         {/*                        and controls.</p>*/}
         {/*                    <h3>Keep <strong>Continuous Attacks</strong> enabled whenever possible.</h3>*/}
         {/*                    <p>*/}
         {/*                        When Continuous Attacks is enabled, CIRT can active poke, prod, and attempt to breach your people*/}
         {/*                        and systems. It is designed to always be enabled, except when you don't want it to be.  It is your way to*/}
         {/*                        always have direct control over CIRT.  If you ever want all intrusive breach activity to stop, disable*/}
         {/*                        Continuous Attacks and all attack activity will cease automatically until you enable it again.*/}
         {/*                    </p>*/}
         {/*                    <h4>Enabling and Disabling Continuous Attacks</h4>*/}
         {/*                    <p> From the Overview tab of the <Link to={"/board/CIRT/external"}>Perimeter module</Link>, the Continuous*/}
         {/*                        Attacks Control widget can be seen.  We've also placed a live copy right here:</p>*/}
         {/*                    <hr/>*/}
         {/*                    <div className={"row"}>*/}
         {/*                        <div className={"col-5"}>*/}
         {/*                            <blockquote className={"blockquote"}>*/}
         {/*                                <CIRTContinuousControlWidget customerId={customerInView}/>*/}
         {/*                                <footer className="blockquote-footer">This is an actual, working control button!</footer>*/}
         {/*                            </blockquote>*/}
         {/*                        </div>*/}
         {/*                        <div className={"col-7"}>*/}
         {/*                            <h4>Live Continuous Attacks Control Widget</h4>*/}
         {/*                            <p>If the control widget on this page says <Badge color="bb-risk-lowest"><IntlMessages id={"badge.cirt.active"}/></Badge> then*/}
         {/*                                Continuous Attacks is working right now.  If it says <Badge color="bb-risk-medium"><IntlMessages id={"badge.cirt.inactive"}/></Badge>*/}
         {/*                                then it is not enabled and you should enable it as soon as you are ready. You can even use the button to the left now and turn it*/}
         {/*                                right back off if you'd like to test it.  You will always know the status by looking at the widget, and you will get*/}
         {/*                                a confirmation on your screen any time you change it.</p>*/}
         {/*                        </div>*/}
         {/*                    </div>*/}
         {/*                    <hr/>*/}
         {/*                    <h3>Sit Back and... <strong>Supervise</strong></h3>*/}
         {/*                    <p>After Continuous Attacks is enabled, and after you're familiar with the other data widgets, the rest is up to you.*/}
         {/*                        Some users, especially security specialists, like to log in to BreachBoard on a weekly or even daily basis. Others check*/}
         {/*                        in monthly, and still others simply await their periodic risk report, which is typically sent out each month with*/}
         {/*                        highlights.</p>*/}
         {/*                    <h3>Feedback, Questions, and Contacting Us</h3>*/}
         {/*                    <p>You will also use the BreachBoard to <Link to={"/board/contact"}>Contact Us</Link> using secure messages, submit feedback on things you like and*/}
         {/*                        don't like, and to answer <Link to={"/board/FAQ"}>FAQs</Link> or to revisit this User's Guide.</p>*/}
         {/*                </div>*/}
         {/*            </AccordionDetails>*/}

         {/*        </Accordion>*/}
             </div>
         </div>
         {/*}*/}

     </div>
     // </SubscriptionBRExpiredModal>
 )
}

export default UsersGuidePage;